import React, { useState, useEffect, Fragment } from 'react';
import InsertText from '../data/insert-text-at-cursor';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    InputGroup,
    Badge,
    CardBody,
    Label
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Property_List,
    gAPI_Ingetration, pAPI_BookingEnginUrlIntegration
} from '../../../../../constants/APIs';
import TestIntegrationBookingUrl from './TestIntegrationBookingUrl';
import LanguageTabs from '../../propinfo/components/LanguageTabs/LanguageTabs';
import ShowChart from '@mui/icons-material/ShowChart';
import { date } from 'yup';
import Validation from '../../../../../components/Validation';
const MyTextbox = React.forwardRef(({ contents, onChange }, ref) => {
    let myContents = contents;

    return (
        <Input
            type="textarea"
            ref={ref}
            name="bookingUrl"
            onChange={onChange}
            placeholder="Booking Engine URL"
            value={myContents}
            rows={5}
        />
    );
});
const tokens = [
    { value: "{CHECK_IN}" },
    { value: "{CHECK_OUT}" },
    { value: "{NIGHTS}" },
    { value: "{ADULTS}" },
    { value: "{CHILDREN}" },
    { value: "{CHILDREN_AGE}" },
    { value: "{ROOM_TYPE}" },
    { value: "{PROMO_CODE}" },
    // { value: "{SOURCE}" },
    { value: "{LANGUAGE}" },
    { value: "{CURRENCY}" }
];


export default function BookingEngineUrlIntegration({ selectedProperty, integrationId, integrationData, locale }) {
    const [selectedLanguage, setSelectedLanguage] = useState(locale);
    const [todayDate, setTodateDate] = useState(moment());
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [isTestIntegration, setIsTestIntegration] = useState(false);
    // const [isDate, setIsDate] = useState(false);
    const [isDelimiter, setIsDelimiter] = useState(false);
    const textbox = React.createRef();
    const [selectedTokens, setSelectedTokens] = useState([]);
    const [inputData, setInputData] = useState(integrationData);
    const [bookingEngineData, setBookingEngineData] = useState({
        propertyId: "",
        dateFormat: "YYYY-MM-DD",
        bookingUrl: "",
        urlDisabled: false,
        childrenAgeDelimiter: "-",
        languageBookingUrl: []
    });
    const [inputUrl, setInputUrl] = useState("");
    function generateRandomColor(index) {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
        ];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    useEffect(() => {
        if (selectedProperty && selectedProperty.length > 0) {
            setBookingEngineData({ ...bookingEngineData, propertyId: selectedProperty[0].id });
            LoadData(locale);
        }
    }, [selectedProperty, locale]);

    const LoadData = (selectedLanguage) => {
        if (integrationData.bookingEngineUrls !== undefined &&
            integrationData.bookingEngineUrls !== null &&
            integrationData.bookingEngineUrls.length > 0 &&
            selectedProperty && selectedProperty.length > 0) {
            let result = [];
            let tok = [];
            // let isdate = false;
            let isDelimiter = false;
            selectedProperty.map(item => {
                result = integrationData.bookingEngineUrls.filter(elem => elem.propertyId === item.id);
            });
            if (result[0] !== undefined) {
                tokens.map((items) => {
                    if (selectedLanguage === "en") {
                        if (result[0].bookingUrl.includes(items.value)) {
                            tok.push({
                                value: items.value
                            })
                        }
                    } else {
                        var langUrl = result[0].languageBookingUrl.filter(x => x.languageCode === selectedLanguage);
                        if (langUrl.length > 0) {
                            if (langUrl[0].bookingUrl.includes(items.value)) {
                                tok.push({
                                    value: items.value
                                })
                            }
                        }
                    }
                });
                var bookingurl = "";
                if (selectedLanguage === "en") {
                    bookingurl = result[0].bookingUrl;
                    setInputUrl(bookingurl);
                    setBookingEngineData(result[0]);
                } else {
                    var langUrl = result[0].languageBookingUrl.filter(x => x.languageCode === selectedLanguage);
                    if (langUrl.length > 0) { bookingurl = langUrl[0].bookingUrl; }

                    setInputUrl(bookingurl);
                    setBookingEngineData(result[0]);
                }
                // if (bookingurl.includes("{CHECK_IN}") || bookingurl.includes("{CHECK_OUT}")) {
                //     isdate = true;
                // }
                // else {
                //     isdate = false;
                // }
                if (bookingurl.includes("{CHILDREN_AGE}")) {
                    isDelimiter = true;
                } else { isDelimiter = false; }
            }
            else {
                setBookingEngineData({
                    propertyId: selectedProperty[0].id,
                    dateFormat: "YYYY-MM-DD",
                    bookingUrl: "",
                    urlDisabled: false,
                    childrenAgeDelimiter: "-",
                    languageBookingUrl: []
                });
            }
            // setIsDate(isdate);
            setIsDelimiter(isDelimiter);
            setSelectedTokens(tok);
        }
    }

    const handleCheckChange = (e) => {
        if (e.target.type === "radio") {
            if (e.target.checked) {
                setInputData({ ...inputData, properties: [e.target.value] });
            }
            if (!e.target.checked) {
                setInputData({ ...inputData, properties: [] });
            }
        }
        else {
            setBookingEngineData({ ...bookingEngineData, urlDisabled: !e.target.checked });
        }
    };
    const ChangeAgeDil = (e) => {
        setBookingEngineData({ ...bookingEngineData, childrenAgeDelimiter: e });
    }
    const handleNameChange = (e) => {
        setInputData({ ...inputData, name: e.target.value });
    }
    const handleDateChange = (e) => {
        setBookingEngineData({ ...bookingEngineData, dateFormat: e.target.value });
    }
    const handleDelimiterChange = (e) => {
        setBookingEngineData({ ...bookingEngineData, childrenAgeDelimiter: e.target.value });
    }
    const handleChange = (evt) => {
        let s = evt.target.value;
        let tok = [];
        tokens.map((items) => {
            if (s.includes(items.value)) {
                tok.push({
                    value: items.value
                })
            }
        });
        // if (s.includes("{CHECK_IN}") || s.includes("{CHECK_OUT}")) {
        //     setIsDate(true);
        // }
        // else {
        //     setIsDate(false);
        // }
        if (s.includes("{CHILDREN_AGE}")) { setIsDelimiter(true) } else { setIsDelimiter(false) }
        setSelectedTokens(tok);
        var existingLang = [...bookingEngineData.languageBookingUrl];
        if (selectedLanguage !== "en") {
            console.log(202, existingLang);
            if (existingLang.length > 0) {
                const index = existingLang.findIndex(
                    (m) => m.languageCode === selectedLanguage
                );
                if (index === -1) {
                    const newStatement = {
                        bookingUrl: s,
                        languageCode: selectedLanguage,
                    };
                    setInputUrl(s);
                    setBookingEngineData({
                        ...bookingEngineData,
                        languageBookingUrl: [...bookingEngineData.languageBookingUrl, newStatement],
                    });
                } else {
                    let newArr = existingLang;
                    newArr[index].bookingUrl = s;
                    setInputUrl(s);
                    setBookingEngineData({
                        ...bookingEngineData,
                        languageBookingUrl: newArr,
                    });
                }
            } else {
                const newStatement = {
                    bookingUrl: s,
                    languageCode: selectedLanguage,
                };
                setInputUrl(s);
                setBookingEngineData({
                    ...bookingEngineData,
                    languageBookingUrl: [...bookingEngineData.languageBookingUrl, newStatement],
                });
            }
        } else {
            setInputUrl(s);
            setBookingEngineData({ ...bookingEngineData, bookingUrl: s });
        }
    };

    const handleInsert = (name) => {
        var text = document.getElementsByName("bookingUrl");
        text[0].focus();
        InsertText(textbox.current, name);
    };

    const handleTestIntegration = () => {
        // if (inputUrl.includes("{CHECK_IN}") || inputUrl.includes("{CHECK_OUT}")) {
        //     setIsDate(true);
        // }
        // else {
        //     setIsDate(false);
        // }
        if (inputUrl.includes("{CHILDREN_AGE}")) { setIsDelimiter(true) } else { setIsDelimiter(false) }
        setIsTestIntegration(true);
    };
    const handleSave = () => {
        let dateformat = bookingEngineData.dateFormat;
        let bookingUrls = [];
        if (inputData.bookingEngineUrls.length > 0) {
            inputData.bookingEngineUrls.filter((i => !i.propertyId.includes(bookingEngineData.propertyId)))
                .map((item => {
                    bookingUrls.push({
                        propertyId: item.propertyId,
                        dateFormat: item.dateFormat,
                        bookingUrl: item.bookingUrl,
                        urlDisabled: item.urlDisabled,
                        languageBookingUrl: item.languageBookingUrl,
                        childrenAgeDelimiter: item.childrenAgeDelimiter,
                    });
                }));
        }
        bookingUrls.push({ ...bookingEngineData, dateFormat: dateformat })

        let data = {
            ...inputData,
            name: 'Booking Engine URL',
            bookingEngineUrls: bookingUrls
        };

        if (integrationId === undefined) {
            AxiosAPI({
                method: 'post',
                url: `${pAPI_BookingEnginUrlIntegration}`,
                data: data,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.href = "/app/pages/integration/applications";
                    }, 300);
                }
            });
        } else {
            AxiosAPI({
                method: 'put',
                url: `${pAPI_BookingEnginUrlIntegration}/${integrationId}?group_id=${getGroupID()}`,
                data: data,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            });
        }
    }
    const setLanguage = (e) => {
        //setLoading(true);
        var lan = e;
        if (e === "zh-TW") {
            lan = "hk";
        }
        setSelectedLanguage(lan);
        LoadData(lan);
        // setLoading(false);
    }
    return (
        <Fragment>
            <CardBody>
                <Row className="mb-4">
                    <Colxx xxs="12">
                        <div className="text-center">
                            <h6>{integrationId === undefined ? "Add" : "Update"} Integration</h6>
                            {selectedProperty && selectedProperty.length > 0 && (
                                <span className="text-muted">
                                    ({selectedProperty[0].name})
                                </span>
                            )}
                            <Separator className="mb-3" />
                            <Form>
                                <FormGroup className="text-left">
                                    <CustomInput
                                        id="lan"
                                        type="checkbox"
                                        label="Enabled"
                                        checked={!bookingEngineData.urlDisabled}
                                        name="disabled"
                                        onChange={handleCheckChange}
                                    />
                                </FormGroup>
                                <FormGroup className="mb-2 text-left">
                                    <Label>Integration Name</Label>
                                    <Input
                                        type="text"
                                        name="integrationName"
                                        value="Booking Engine URL"
                                        readOnly
                                        disabled
                                    />
                                </FormGroup>
                                {selectedProperty && selectedProperty.length > 0 && (
                                    <FormGroup>
                                        <LanguageTabs
                                            selectedProperty={selectedProperty[0].id}
                                            selectedTab={selectedLanguage === "hk" ? "zh-TW" : selectedLanguage}
                                            setLanguage={setLanguage}
                                        ></LanguageTabs>
                                    </FormGroup>
                                )}
                                <FormGroup className="mb-2 text-left">
                                    <Label>Booking Engine URL</Label>
                                    <MyTextbox contents={inputUrl}
                                        ref={textbox} onChange={handleChange} />
                                </FormGroup>
                                <Row>
                                    {/* {isDate && ( */}

                                    <Colxx sm={3} className="mb-5">
                                        <Label>Date Format</Label>
                                        <Input
                                            type="select"
                                            name="dateformat"
                                            onChange={handleDateChange}
                                            value={bookingEngineData.dateFormat}
                                        >
                                            <option value={"YYYY-MM-DD"}>{moment(todayDate).format('YYYY-MM-DD')} (YYYY-MM-DD)</option>
                                            <option value={"DD/MM/YYYY"}>{moment(todayDate).format('DD/MM/YYYY')} (DD/MM/YYYY)</option>
                                            <option value={"MM/DD/YYYY"}>{moment(todayDate).format('MM/DD/YYYY')} (MM/DD/YYYY)</option>
                                            <option value={"DD-MM-YYYY"}>{moment(todayDate).format('DD-MM-YYYY')} (DD-MM-YYYY)</option>
                                            <option value={"MM-DD-YYYY"}>{moment(todayDate).format('MM-DD-YYYY')} (MM-DD-YYYY)</option>
                                            <option value={"MMM D, YYYY"}>{moment(todayDate).format('MMM D, YYYY')} (MMM D, YYYY)</option>
                                        </Input>
                                    </Colxx>
                                    {/* )} */}
                                    {isDelimiter &&
                                        <Colxx sm={3} className="mb-5">
                                            <Label>Children Age Delimiter</Label>
                                            <Input
                                                type="text"
                                                value={bookingEngineData.childrenAgeDelimiter}
                                                onChange={handleDelimiterChange}
                                                name="childrenAgeDelimiter"
                                            >
                                            </Input>
                                        </Colxx>
                                    }
                                </Row>
                                <FormGroup className="text-left">
                                    <label>Insert Placeholder</label><br />
                                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                        {tokens.map((token, index) => {
                                            return (
                                                <div key={index} style={{ marginRight: "1.5px" }}>
                                                    <Button
                                                        color={generateRandomColor(index)}
                                                        className="mb-2"
                                                        outline
                                                        size="xs"
                                                        onClick={() => handleInsert(token.value)}
                                                    >{token.value}</Button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </FormGroup>
                                {!isTestIntegration && inputUrl !== "" && (
                                    <FormGroup>
                                        <Button
                                            color="secondary"
                                            size="xs"
                                            onClick={() => handleTestIntegration()}
                                        >Test Integration</Button>
                                    </FormGroup>
                                )}

                                <TestIntegrationBookingUrl
                                    visible={isTestIntegration}
                                    selectedTokens={selectedTokens}
                                    inputData={bookingEngineData}
                                    inputUrl={inputUrl}
                                    ChangeAgeDil={ChangeAgeDil}
                                ></TestIntegrationBookingUrl>
                            </Form>

                            <Separator className="mt-4" />
                            <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                {integrationId === undefined ? (
                                    <Button color="primary" size="xs"
                                        onClick={handleSave}
                                    >
                                        Create New Integration
                                    </Button>) : (<Button color="primary" size="xs"
                                        onClick={handleSave}
                                    >
                                        Update Integration
                                    </Button>)}
                                {/* <Button size="xs" color="dark" outline
                                    onClick={() => setIsTestIntegration(!isTestIntegration)}
                                >
                                    Cancel
                                </Button> */}
                            </ButtonGroup>
                        </div>
                    </Colxx>
                </Row>
            </CardBody>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}